import { Modal } from 'antd';

interface DeleteCatalogoConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function DeleteCatalogoConfirmModal({
  open,
  onConfirm,
  onCancel,
  loading,
}: DeleteCatalogoConfirmModalProps) {
  return (
    <Modal
      title="¿Eliminar este registro?"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Eliminar"
      cancelText="Cancelar"
      okButtonProps={{ danger: true }}
    >
      <p>
        El registro se eliminará si no tiene referencias ni hijos. Para datos utilizados por el
        sistema, recomendamos desactivarlo en lugar de eliminarlo.
      </p>
    </Modal>
  );
}
